export default {
  nav: {
    services: 'Diensten',
    portfolio: 'Portfolio',
    process: 'Werkwijze',
    about: 'Over ons',
    hosting: 'Hosting',
    contact: 'Contact',
    cta: 'Start een gesprek',
  },
  hero: {
    badge: 'Beschikbaar voor nieuwe projecten',
    line1: 'Jouw idee.',
    line2: 'Onze code.',
    line3: 'Live in weken.',
    subtitle: 'Jij hebt een idee, wij zorgen dat het ook echt werkt. Design, frontend, backend en mobiel. Van eerste gesprek tot live product, zonder gedoe.',
    cta_primary: 'Vertel ons je idee',
    cta_secondary: 'Bekijk ons werk',
    scroll: 'Scroll',
    code_comment: '// Hallo. Wij zijn Pixelated.',
    code_output: 'jouw product',
  },
  services: {
    label: '// Wat wij voor je bouwen',
    title: 'Diensten',
    subtitle: 'Geen bureau met lagen en overlegrondes. Je praat direct met de mensen die ontwerpen én bouwen. Kort lijntje, hoge snelheid.',
    web_title: 'MVP Development',
    web_desc: 'Je wil weten of je idee werkt voordat je er alles in stopt. Wij bouwen een strak, functioneel product waarmee je kunt testen, pitchen en doorgroeien. Snel live, klaar om te schalen.',
    web_deliverable: 'Werkend product, klaar om te testen',
    app_title: 'Design & Development',
    app_desc: 'Een designer die niet kan bouwen kost je dubbel geld. Wij doen beide: van wireframe tot werkende code. Elk detail klopt, visueel én technisch.',
    app_deliverable: 'Design én code uit één hand',
    solutions_title: 'Software Uitbreiden',
    solutions_desc: 'Jouw systeem werkt maar groeit niet meer mee. Wij duiken in de bestaande codebase, begrijpen wat er staat en bouwen het verder zonder alles om te gooien.',
    solutions_deliverable: 'Uitbreiding zonder herstart of drama',
  },
  portfolio: {
    label: '// Wat wij gebouwd hebben',
    title: 'Uitgelichte projecten',
    subtitle: 'Echte projecten, echte klanten. Dit is wat wij voor mensen zoals jou gemaakt hebben.',
    view_project: 'Bekijk project',
    view_all: 'Bekijk alle projecten',
  },
  about: {
    label: '// Wie wij zijn',
    title: 'Over ons',
    bio1: 'Pixelated is een compacte development-studio uit Nederland. Wij bouwen complete digitale producten voor ondernemers en bedrijven die iets willen neerzetten. Geen bureau-omweg, geen account managers. Je praat rechtstreeks met de makers.',
    bio2: 'Wij geloven dat goede software begint bij écht begrijpen wat iemand nodig heeft. Daarom stellen we eerst de lastige vragen, voordat er ook maar één regel code geschreven wordt. Het resultaat? Een product dat echt werkt voor jou én voor je gebruikers.',
    highlight1: 'Direct contact, geen tussenlagen',
    highlight2: 'Design én development uit één hand',
    highlight3: 'We zeggen het als je minder nodig hebt',
    stat1_num: '20+',
    stat1_label: 'projecten afgeleverd',
    stat2_num: '5+',
    stat2_label: 'jaar ervaring',
    stat3_num: '1',
    stat3_label: 'vast aanspreekpunt',
    stack_title: 'Tech Stack',
  },
  hosting: {
    label: '// Hosting & beheer',
    title: 'Hosting? Ook geregeld.',
    text: 'Een product bouwen is stap één. Het betrouwbaar online houden stap twee. Voor hosting en beheer werken we samen met onze partner Quixor: snelle servers, 24/7 monitoring en proactief onderhoud. Wij bouwen, zij hosten — jij hebt er geen omkijken naar.',
    cta: 'Ontdek Quixor',
    note: 'Officiële hosting-partner van Pixelated',
  },
  contact: {
    label: '// Laten we praten',
    title: 'Zeg hallo',
    intro: 'Stuur ons een bericht. Geen verplichtingen, geen standaard offerte. Gewoon een eerlijk gesprek over wat je wil bouwen en of wij de juiste partij zijn om dat te doen.',
    email_label: 'E-mail',
    response_label: 'Reactietijd',
    response_value: 'Binnen 24 uur',
    location_label: 'Locatie',
    location_value: 'Nederland, remote beschikbaar',
    form_name: 'Naam',
    form_name_placeholder: 'Jouw naam',
    form_email: 'E-mail',
    form_type: 'Type project',
    form_type_placeholder: 'Kies een type',
    form_type_website: 'Website / webapplicatie',
    form_type_app: 'Mobiele app',
    form_type_solution: 'Bestaande software uitbreiden',
    form_type_mvp: 'MVP bouwen vanaf nul',
    form_type_other: 'Iets anders',
    form_budget: 'Budget',
    form_budget_placeholder: 'Kies een budget',
    form_message: 'Bericht',
    form_message_placeholder: 'Vertel ons wat je wil bouwen. Hoe meer context, hoe beter we kunnen helpen.',
    form_submit: 'Verstuur bericht',
    success: 'Bedankt! Je bericht is verzonden. We nemen snel contact op.',
    error: 'Er ging iets mis. Probeer het opnieuw of mail direct naar info@pixelated-it.com',
    sending: 'Verzenden...',
  },
  werkwijze: {
    back: 'Terug naar home',
    title: 'Zo werken wij',
    subtitle: 'Kort, direct en zonder gedoe. Dit is hoe samenwerken met ons eruitziet.',
    step1_title: 'We praten',
    step1_desc: 'We bespreken jouw idee, context en doel. Geen intake-formulier. Gewoon een open gesprek over wat je wil bouwen, waarom en wat dat vraagt.',
    step1_deliverable: 'Duidelijkheid over aanpak en haalbaarheid',
    step2_title: 'We doen een voorstel',
    step2_desc: 'Je krijgt een concreet voorstel: aanpak, planning en prijs. Geen kleine lettertjes, geen verrassingen achteraf. Als iets niet haalbaar is, zeggen we dat ook.',
    step2_deliverable: 'Helder voorstel met tijdlijn en prijs',
    step3_title: 'We bouwen samen',
    step3_desc: 'We werken iteratief. Elke week zie je progressie. Je kunt feedback geven, vragen stellen en bijsturen. Dit is jouw product, wij bouwen het met jou.',
    step3_deliverable: 'Wekelijkse updates + werkende software',
    step4_title: 'Live',
    step4_desc: 'Deployment, overdracht en uitleg. Je weet precies hoe alles werkt en hoe je het zelf beheert. Na de launch blijven we beschikbaar voor vragen.',
    step4_deliverable: 'Live product + volledige documentatie',
    cta_title: 'Klinkt dit goed?',
    cta_desc: 'Stap 1 is vrijblijvend. Vertel ons wat je wil bouwen.',
    cta_button: 'Stuur ons een bericht',
  },
  footer: {
    built_with: 'Gebouwd met Vue & Spring Boot',
  },
  portfolio_page: {
    back: 'Terug naar home',
    subtitle: 'Alle projecten, van ruwe schets tot werkend product.',
    filter_all: 'Alle',
    filter_web: 'Web',
    filter_mobile: 'Mobile',
    filter_backend: 'Backend',
    view_project: 'Bekijk project',
    category_web: 'Web',
    category_mobile: 'Mobile',
    category_backend: 'Backend',
    empty: 'Geen projecten in deze categorie.',
  },
}
